import React from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence, motion } from 'framer-motion';
import { LuMoon, LuSun } from 'react-icons/lu';
import { useTheme } from '../../contexts/ThemeContext';
import IconButton from '../ui/IconButton';
import { useTranslation } from '../../i18n/LanguageContext';

/** Light/dark switch for the top bar, with a rotating icon swap. */
const ThemeToggleButton = ({ className = '' }) => {
  const { isDarkMode, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <IconButton label={isDarkMode ? t('shell.switchToLight') : t('shell.switchToDark')} onClick={toggleTheme} className={className}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={isDarkMode ? 'sun' : 'moon'}
          className="tw-block"
          initial={{ rotate: -90, scale: 0.4, opacity: 0 }}
          animate={{ rotate: 0, scale: 1, opacity: 1 }}
          exit={{ rotate: 90, scale: 0.4, opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          {isDarkMode ? <LuSun className="tw-h-[18px] tw-w-[18px]" /> : <LuMoon className="tw-h-[18px] tw-w-[18px]" />}
        </motion.span>
      </AnimatePresence>
    </IconButton>
  );
};

ThemeToggleButton.propTypes = {
  className: PropTypes.string,
};

export default ThemeToggleButton;
